import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#ffde00',
      light: 'rgb(255, 228, 51)',
      dark: 'rgb(178, 155, 0)',
      contrastText: 'rgba(0, 0, 0, 0.87)',
      black: '#000',
      white: '#fff'
    },
    secondary: {
      main: '#404040',
      light: 'rgb(102, 102, 102)',
      dark: 'rgb(44, 44, 44)',
      contrastText: '#fff'
    },
    high: '#e53935',
    medium: '#f57c00',
    low: '#ffde00',
    overdue: '#ef5350',
    completed: '#81d4fa',
    received: '#66bb6a',
    open: 'rgba(255, 222, 0, 1)',
    published: 'rgba(129, 199, 132, 1)',
    draft: 'rgba(249, 168, 37, 1)',
    closed: 'rgba(224, 224, 224, 1)',
    archived: 'rgba(58,58,58, 1)',
    frozen: 'rgb(18, 79, 214, 0.7)',
    promotionStatus: {
      openlocal: '#ffde00',
      opennational: '#ceb617',
      publishednational: '#0aa210',
      publishedlocal: '#226f25',
      draftlocal: '#f9a825',
      draftnational: '#b5740b',
      closed: 'rgba(224, 224, 224, 1)',
      archived: '#900707',
      frozen: '#655b5b'
    }
  },
  typography: {
    button: {
      fontSize: '0.875rem'
    },
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'Roboto',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(',')
  }
})
